import { getApi, postApi } from 'apis';

const getHourlyLogs = async (data: any) => {
	return await getApi('/log-assignment', data);
};

const createHourlyLogs = async (data: any) => {
	return await postApi('/log-assignment', data);
};

const createBulkTimeLogsForEmployee = async (data: any) => {
	return await postApi('/timeActivities/bulk-employee-logs', data);
};

const getTimeActivity = async (data: any) => {
	return await getApi('/log-assignment/time-activity', data);
};

export const timeLogsAssignmentApi = {
	getHourlyLogs,
	createHourlyLogs,
	getTimeActivity,
	createBulkTimeLogsForEmployee,
};
